import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Colorado Springs", to: "/location" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white border-b border-gray-100"
          : "bg-gradient-to-b from-black/50 to-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer flex-shrink-0">
          <div className="h-11 flex items-center justify-center">
            <img
              src="https://storage.readdy-site.link/project_files/4919a3d8-a024-46be-8105-a51ccf5c6eed/37fd96f4-a6bd-46d3-b823-ee4bb75b1a06_M179026---Web360-MU---Logo.png?v=e3931809e172ac5bc78535d28d071904"
              alt="Westec Builders Logo"
              className={`h-11 w-auto object-contain transition-all duration-300 ${
                scrolled ? "" : "brightness-0 invert"
              }`}
            />
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium font-body transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === link.to
                  ? "text-brand-amber"
                  : scrolled
                  ? "text-brand-dark hover:text-brand-amber"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA group */}
        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:+17195550100"
            className={`inline-flex items-center gap-2 text-sm font-semibold font-body transition-colors cursor-pointer whitespace-nowrap px-4 py-2.5 rounded-md ${
              scrolled
                ? "text-brand-dark hover:text-brand-amber border border-brand-warm-deep hover:border-brand-amber"
                : "text-white/90 hover:text-white border border-white/30 hover:border-white/60"
            }`}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm" />
            </span>
            (719) 555-0100
          </a>
          <Link
            to="/#estimate"
            className="bg-brand-amber text-white text-sm font-semibold font-body px-5 py-2.5 rounded-md hover:bg-brand-amber-light transition-colors cursor-pointer whitespace-nowrap"
          >
            Get a Free Estimate
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          className={`lg:hidden cursor-pointer w-10 h-10 flex items-center justify-center rounded-md ${
            scrolled ? "text-brand-dark" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
          </span>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm font-medium font-body text-brand-dark hover:text-brand-amber transition-colors cursor-pointer py-1"
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-3 border-t border-brand-warm-deep flex flex-col gap-3">
            <a
              href="tel:+17195550100"
              className="inline-flex items-center gap-2 text-sm font-semibold font-body text-brand-dark cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-brand-amber text-sm" />
              </span>
              (719) 555-0100
            </a>
            <Link
              to="/#estimate"
              className="bg-brand-amber text-white text-sm font-semibold font-body px-5 py-3 rounded-md text-center cursor-pointer whitespace-nowrap"
            >
              Get a Free Estimate
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
